import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationExtras } from '@angular/router';
import { LoginService } from './../authentication/login/services/login.service';
import { UserRoles } from './globals';
import { NotificationService } from '../shared/services/notification.service';

@Injectable()
export class AuthGuard  {
    constructor(private router: Router, private loginService: LoginService,
        private notification: NotificationService,) {

    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        var isUserLoggedIn = this.loginService.isUserLoggedIn();
        if (isUserLoggedIn) {
            const allowedUserRoles = this.getRoutePermissions(route);
            var result = this.checkPermission(allowedUserRoles, route);
            this.notification.clearAllToasts();
            return result;
        } else {
            this.router.navigate(['']);
            return false;
        }
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    private getRoutePermissions(route: ActivatedRouteSnapshot): UserRoles[] {
        if (route.data && route.data.UserRoles) {
            return route.data.UserRoles as UserRoles[];
        }
        return null;
    }

    private checkPermission(allowedUserRoles: UserRoles[], route: ActivatedRouteSnapshot,): boolean {
        let isRoleAllowed: boolean = false;
        var loginuserRole = this.loginService.getLoginUserRole();

        if (loginuserRole.toUpperCase() == UserRoles.AT) {
            return true;
        }

        if (allowedUserRoles == null || (allowedUserRoles != null && allowedUserRoles.indexOf('All') > -1)) {
            return true;
        }
        //  if(this.loginService.isUserExternal()==true && allowedUserRoles.includes('Internal'))
        //  {
        //      return false;
        //  }
        else {
            allowedUserRoles.forEach(a => {
                if (a == loginuserRole.toUpperCase()) {
                    isRoleAllowed = true;
                }
            });

        }

        if (!isRoleAllowed) {
            this.router.navigate(['']);
            return false;
        }
        else {
            return true;
        }
    }
}
